export enum EPermissionType {
  OccurenciesWithConflicts = "OccurenciesWithConflicts",
  OccurrencceExceedCapacity = "OccurrencceExceedCapacity",
  AllOccurrenceExceedCapacity = "AllOccurrenceExceedCapacity",
  CanBookByExchangeByRule = "CanBookByExchangeByRule",
  DelegateByInOutPolicy = "DelegateByInOutPolicy",
  DeclinedByInPolicy = "DeclinedByInPolicy",
  VRConfigWrong = "VRConfigWrong",
  CloseDate = "CloseDate",
  OpenHours = "OpenHours",
  ViolatePriority = "ViolatePriority",
  DeclinedByOutPolicy = "DeclinedByOutPolicy",
  ExceedCapacity = "ExceedCapacity",
  CannotBookByExchangeByRule = "CannotBookByExchangeByRule",
  PreCloseDate = "PreCloseDate",
  PrioritizedReservation = "PrioritizedReservation",
  HotDeskResource = "HotDeskResource",
  Unavailable = "Unavailable",
  NotAllowRecurringBooking = "NotAllowRecurringBooking",
  ResourceInClosedHours = "ResourceInClosedHours",
}

export enum EDisableRule {
  DisablePooledResource = "DisablePooledResource",
  DisableVRResource = "DisableVRResource",
  DisableHotDeskResource = "DisableHotDeskResource",
  DisableOpeningHours = "DisableOpeningHours",
}

export enum EBusyStatus {
  Busy = "busy",
  Free = "free",
  Tentative = "tentative",
  WorkingElsewhere = "workingelsewhere",
  OutOfOffice = "oof",
}

export enum EForceOpenOrder {
  None,
  NormalOrder,
  NormalOrShareOrder,
  ShareOrder
}
 
export enum EStatusResource {
    Available = "available",
    Unavailable = "unavailable",
    Disable = "disable",
}

export enum ETypeOrderResource {
  NewOrder = "New Order",
  ChangeOrder = "Change Order",
  MoveOrder = "Move Order",
}
